export default ` 
    button {
        background: none;
    }
`;
